import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IEvl0110MState, IEvlMemberListState, StatusFilter, TabType } from '../../models/evl/evl0110m_model';

const initialState: IEvl0110MState = {
  selectedTeam     : 'all',
  selectedEvalType : 'all',
  selectedStatus   : 'all',
  searchName       : '',
  expandedRowKeys  : [],
  allEmployees     : [],
  rawBackendData   : [],
  pageSize         : 20,
  currentPage      : 1,
  activeTab        : 'my'
};

export const evl0110m_Slice = createSlice({
  name         : 'evl0110m_Slice',
  initialState : initialState,
  reducers     : {
    initState: (state) => {
      Object.assign(state, {
        ...initialState,
      });
    },
    setSelectedTeam: (state, action: PayloadAction<string>) => {
      state.selectedTeam = action.payload;
    },
    setSelectedEvalType: (state, action: PayloadAction<string>) => {
      state.selectedEvalType = action.payload;
    },
    setSelectedStatus: (state, action: PayloadAction<StatusFilter>) => {
      state.selectedStatus = action.payload;
    },
    setSearchName: (state, action: PayloadAction<string>) => {
      state.searchName = action.payload;
    },
    setExpandedRowKeys: (state, action: PayloadAction<string[]>) => {
      state.expandedRowKeys = action.payload;
    },
    setAllEmployees: (state, action: PayloadAction<IEvlMemberListState[]>) => {
      state.allEmployees = action.payload;
    },
    setRawBackendData: (state, action: PayloadAction<any[]>) => {
      state.rawBackendData = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    resetFilters: (state) => {
      state.selectedTeam     = 'all';
      state.selectedEvalType = 'all';
      state.selectedStatus   = 'all';
      state.searchName       = '';
      state.currentPage      = 1;
    },
    resetPage: (state) => {
      state.currentPage = 1;
    },
    setActiveTab: (state, action: PayloadAction<TabType>) => {
      state.activeTab = action.payload;
    },
  },
});

export default evl0110m_Slice.reducer;
export const Evl0110mAction = evl0110m_Slice.actions;
export const Evl0110mReducer = evl0110m_Slice.reducer;